import {Redirect, Route, Switch} from "react-router-dom";
import {IndexPage} from "~/apps/packages/vessel-calls/components/IndexPage";
import React, {useEffect} from "react";
import {AccessRequired} from "~/apps/core/ui/AccessRequired";
import {useApolloClient} from "@apollo/client";
import {DetailPage} from "~/apps/packages/vessel-calls/components/DetailPage";
import {BrowserRouter} from "~/apps/core/BrowserRouter";
import {ServiceInterview} from "~/customers-experience/ServiceInterview";


export const APP_NAME = "vessel-calls";
export const APP_VERSION = "1.0.0";


export const VesselCallsApp = () => {
    const client = useApolloClient();

    // Invalidate apollo cache when leave service
    useEffect(() => () => {
        client.cache.evict({id: "ROOT_QUERY", fieldName: "vesselCalls"});
        client.cache.evict({id: "ROOT_QUERY", fieldName: "vesselCall"});
    }, []);

    return (
        <AccessRequired title="Подход флота">
            <BrowserRouter basename="/apps/vessel-calls">
                <ServiceInterview serviceID={APP_NAME} serviceVersion={APP_VERSION}>
                    <Switch>
                        <Route path="/:id" exact={true}>
                            <DetailPage/>
                        </Route>
                        <Route path="/" exact={true}>
                            <IndexPage/>
                        </Route>
                        <Route path="*" render={() => <Redirect to="/"/>}/>
                    </Switch>
                </ServiceInterview>
            </BrowserRouter>
        </AccessRequired>
    )
}

export default VesselCallsApp;